// Inline `onclick="toggleMobileMenu()"` handlers in index_raw.html require
// these to be available on `window` — esbuild IIFE alone won't expose them.
let mobileMenuOpen = false;

function setMenuState(open: boolean): void {
  mobileMenuOpen = open;
  const mobileMenu = document.querySelector(".mobile-menu");
  const menuIcon = document.querySelector(".menu-icon");
  const closeIcon = document.querySelector(".close-icon");
  if (!mobileMenu || !menuIcon || !closeIcon) return;

  if (open) {
    mobileMenu.classList.add("open");
    menuIcon.classList.add("hidden");
    closeIcon.classList.remove("hidden");
  } else {
    mobileMenu.classList.remove("open");
    menuIcon.classList.remove("hidden");
    closeIcon.classList.add("hidden");
  }
}

export function toggleMobileMenu(): void {
  setMenuState(!mobileMenuOpen);
}

export function closeMobileMenu(): void {
  setMenuState(false);
}

declare global {
  interface Window {
    toggleMobileMenu: () => void;
    closeMobileMenu: () => void;
  }
}

export function exposeMobileMenuGlobals(): void {
  window.toggleMobileMenu = toggleMobileMenu;
  window.closeMobileMenu = closeMobileMenu;
}
